
import {
  getAllRole,
  upDataUser,
  addUser,
  getUserDetails
} from "@/api/api-basic";
import {
  addCarBrandtemUpgrade,
  upDataCar,
  getCarBrandDetails,
  getCarSelectOpts
} from "@/api/api-car";
import { Component, Vue } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import validate from "@/common/regular";
import i18n from "@/config/i18n";

@Component
export default class SystemConfigCarAdd extends Vue {
  private carRankList = [];
  private typeList = [];
  private modeList = [];

  private modalShow = false;
  private getLoading = false;
  private isQuery = false;
  private loading = true;
  private roleList: objAny[] = [];
  private isAdd = false;
  private FormData: objAny = {};
  private modalTitle = i18n.t("car.addModel.addTitle");
  /**
   * 新增表单验证
   */
  private ruleInline: objAny = {
    brand: [
      {
        required: true,
        message: i18n.t("car.tips.brandTips"),
        trigger: "blur",
        max: 100
      }
    ],
    serial: [
      {
        required: true,
        message: i18n.t("car.tips.serialTips"),
        trigger: "blur"
      }
    ],
    model: [
      {
        required: true,
        message: i18n.t("car.tips.modelTips"),
        trigger: "blur"
      }
    ],
    fuelType: [
      {
        required: true,
        message: i18n.t("car.tips.fuelTypeTips"),
        trigger: "change"
      }
    ],
    /*    type: [
      {
        required: true,
        // message: i18n.t("car.typeRequired"),
        trigger: "change"
      }
    ],
    seats: [
      {
        required: true,
        type: "number",
        // message: i18n.t("car.seatsRequired"),
        trigger: "blur"
      }
    ],
    carRank: [
      {
        required: true,
        // message: i18n.t("car.carRankRequired"),
        trigger: "change"
      }
    ],
    rechargeMileage: [
      {
        required: true,
        type: "number",
        validator: validate.rechargeMileage, // Assuming a custom validator for recharge mileage
        trigger: "blur"
      }
    ],
    capacity: [
      {
        required: true,
        type: "number",
        validator: validate.capacity, // Assuming a custom validator for capacity
        trigger: "blur"
      }
    ]*/
    seats: [
      {
        type: "number",
        validator: (rule, value, callback) => {
          const regex = /^[1-9]\d*$/;
          console.log(value.length);
          if (regex.test(value) || !value) {
            if (value.length >= 6) {
              callback(new Error(i18n.t("car.inputPositiveInteger6DigitsMax")));
            } else {
              callback();
            }
          } else {
            callback(new Error(i18n.t("car.inputPositiveInteger6DigitsMax")));
          }
        },
        trigger: "blur"
      }
    ],
    capacity: [
      {
        type: "number",
        validator: (rule, value, callback) => {
          const regex = /^\d{1,4}(\.\d{1,2})?$/;
          if (regex.test(value) || !value) {
            callback();
          } else {
            callback(new Error(i18n.t("car.inputLimitDescription")));
          }
        },
        trigger: "blur"
      }
    ],
    rechargeMileage: [
      {
        type: "number",
        validator: (rule, value, callback) => {
          const regex = /^\d{1,4}(\.\d{1,2})?$/;
          if (regex.test(value) || !value) {
            callback();
          } else {
            callback(new Error(i18n.t("car.inputLimitDescription")));
          }
        }, // Assuming a custom validator for capacity
        trigger: "blur"
      }
    ]
  };

  private baseForm: objAny = {
    brand: "",
    serial: "",
    model: "",
    fuelType: "",
    type: "",
    seats: null,
    carRank: "",
    rechargeMileage: null,
    capacity: null
  };
  private formItem: objAny = { ...this.baseForm };
  private itemData: objAny = {};

  public seatsHandle(e) {
    if (e.length > 2) {
    }
  }

  public open(item: objAny, type: string) {
    if (!this.FormData.$el) {
      this.$nextTick((): void => {
        this.FormData = this.$refs["formItem"];
      });
    } else {
      this.handleReset();
    }

    this.modalShow = true;
    this.loading = true;
    if (type === "query") {
      this.isQuery = true;
    } else {
      this.isQuery = false;
    }
    this.roleList = [];
    if (type === "add") {
      this.isAdd = true;
      this.formItem = this.baseForm;
      this.modalTitle = i18n.t("car.addModel.addTitle");
      this.getRoleSelect();
    } else {
      this.isAdd = false;
      this.getCarBrandDetails(item.id);
      this.modalTitle = i18n.t("car.addModel.editTitle");
    }
  }

  public handleSubmit(): void {
    this.loading = true;
    (this.$refs["formItem"] as objAny).validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      } else {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true;
        });
      }
    });
  }

  public closeModal(): void {
    this.modalShow = false;
  }

  public handleReset() {
    this.FormData.resetFields();
  }

  async submitData(): Promise<void> {
    let ret: objAny;
    const params: objAny = { ...this.formItem };
    const json: objAny = JSON.parse(JSON.stringify(params));

    if (this.formItem.id) {
      json.userPkId = this.formItem.userId;
      delete json.createTime;
      ret = await upDataCar(json);
    } else {
      ret = await addCarBrandtemUpgrade(json);
    }
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("operationSucess"));
      this.$emit("success");
      this.modalShow = false;
    }
    // this.loading = false;
  }

  async getRoleSelect(): Promise<void> {
    const json: objAny = {};
    if (!this.isAdd) {
      json.roleType = this.itemData.roleType;
    }
    const ret = await getAllRole(json);
    const list: objAny[] = [];
    if (ret.status === this.$config.apiStatus) {
      ret.data.map((item: objAny) => {
        if (
          (this.isAdd && item.roleType === 1) ||
          (this.isAdd && item.roleType === 6)
        ) {
          list.push(item);
        } else {
          list.push(item);
        }
      });
      this.roleList = list;
    }
  }

  async getCarBrandDetails(id: string): Promise<void> {
    const ret = await getCarBrandDetails({ id: id });
    if (ret.status === this.$config.apiStatus) {
      const item = ret.data[0] || [];
      this.itemData = item;
      this.formItem = item;
    }
  }

  async getCarSelectOpts(): Promise<void> {
    const ret = await getCarSelectOpts();
    if (ret.status === this.$config.apiStatus) {
      this.carRankList = ret.data[0].carRankList;
      this.typeList = ret.data[0].typeList;
      this.modeList = ret.data[0].modeList;
    }
  }

  mounted() {
    this.$emit("getChild", this);
    this.getCarSelectOpts();
  }
}
